import styled from "styled-components";

export const RecordFormStyle = styled.div`
	padding: 20px;

	h2 {
		margin-bottom: 20px;
	}
`;
